export default "__VITE_ASSET__4C6cmFxy__"